<template>
  <div data-testid="qv-direct-banner">
    <!-- Neutral mode line: the Otsemudel chip, its definition on hover. RED-356
         (Toomas 02.10): the confidence and quality tags are gone from under the
         price; the measured numbers live in "Mudeli kvaliteet". -->
    <div class="flex flex-wrap items-center justify-center gap-2 text-sm text-slate-500">
      <Tag
        v-tooltip.bottom="$t('messages.quickValuation.direct.definition')"
        data-testid="qv-direct-badge"
        :value="$t('messages.quickValuation.direct.badge')"
        severity="info"
        class="text-xs! cursor-help"
      />
    </div>
    <!-- RED-262 Gate v0: the comps-first gate fell back to the direct model — a calm
         notice in place of the info line. Chip stays the RED-290 badge; no second chip.
         Jaan's sentence (16.10) and nothing else: no title, no %, no second line. -->
    <Message
      v-if="isGateBackup"
      data-testid="qv-gate-backup-banner"
      severity="secondary"
      :closable="false"
      class="mt-3 text-left"
    >
      {{ $t('messages.quickValuation.gate.backupReason') }}
    </Message>
    <p v-else data-testid="qv-direct-info-line" class="mt-2 text-xs text-slate-400">
      {{ $t('messages.quickValuation.direct.definition') }}
    </p>

    <!-- Prominent warning for low-confidence routes (hard_residual & co) -->
    <Message
      v-if="showWarning"
      data-testid="qv-direct-low-confidence"
      severity="warn"
      :closable="false"
      class="mt-3 text-left"
    >
      {{ $t('messages.quickValuation.direct.lowConfidenceWarning') }}
    </Message>
    <!-- RED-363: measured accuracy in this segment is low (sealed confidence) -->
    <Message
      v-else-if="showSealedWarning"
      data-testid="qv-direct-sealed-low"
      severity="warn"
      :closable="false"
      class="mt-3 text-left"
    >
      {{ $t('messages.quickValuation.direct.sealedLowWarning') }}
    </Message>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  confidence: { type: String, default: null },
  lowConfidenceFlag: { type: Boolean, default: false },
  // RED-262 Gate v0 verdict (`prediction.gate`); only `path === 'backup_direct'` renders.
  gate: { type: Object, default: null },
  // RED-363 `prediction.sealed`: the out-of-time measurement. Its `confidence`
  // decides the measured-accuracy warning; absent on rows stored before RED-363.
  sealed: { type: Object, default: null },
})

const isSealed = computed(() => typeof props.sealed?.id === 'string' && props.sealed.id !== '')

// The route's structural warning (hard_residual). Rows stored before RED-363
// folded the route's "low" into the flag already; the sealed "low" is measured
// accuracy and gets its own sentence below instead of "few transactions".
const showWarning = computed(() => props.lowConfidenceFlag || (!isSealed.value && props.confidence === 'low'))
const showSealedWarning = computed(() => isSealed.value && props.sealed.confidence === 'low')

const isGateBackup = computed(() => props.gate?.path === 'backup_direct')
</script>
